import React from "react";
import { View, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";

function InspectionIcon(props) {
  return (
    <View style={styles.container}>
      <MaterialCommunityIcons
        name="shield-outline"
        {...props.style}
        size={22}
      />
      <View style={styles.searchIcon}>
        <FontAwesome5 name="search" {...props.style} size={9} />
      </View>
    </View>
  );
}

export default InspectionIcon;

const styles = StyleSheet.create({
  container: {
    marginBottom: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  searchIcon: {
    position: "absolute",
    right: "26%",
  },
});
